import { render, staticRenderFns } from "./chat-media-preview.vue?vue&type=template&id=0aa16694&scoped=true&"
import script from "./chat-media-preview.vue?vue&type=script&lang=js&"
export * from "./chat-media-preview.vue?vue&type=script&lang=js&"
import style0 from "./chat-media-preview.vue?vue&type=style&index=0&id=0aa16694&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa16694",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VProgressCircular})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0aa16694')) {
      api.createRecord('0aa16694', component.options)
    } else {
      api.reload('0aa16694', component.options)
    }
    module.hot.accept("./chat-media-preview.vue?vue&type=template&id=0aa16694&scoped=true&", function () {
      api.rerender('0aa16694', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/atendimento/components/chat-media-preview/chat-media-preview.vue"
export default component.exports